import {ViewPopup} from './ViewPopup'

export class UIPopupManager {
    static activePopups: ViewPopup[] = []

    static trackPopup(popup: ViewPopup) {
        UIPopupManager.activePopups.push(popup)
    }

    static untrackPopup(popupToRemove: ViewPopup) {
        UIPopupManager.activePopups = UIPopupManager.activePopups.filter((popup: ViewPopup) => popup != popupToRemove)
    }

    static isPopupTracked(popupToFind: ViewPopup): boolean {
        const popupFound = UIPopupManager.activePopups.find((popup: ViewPopup) => popup == popupToFind)
        return popupFound == undefined ? false : true
    }

    static closeAllPopups() {
        UIPopupManager.removeActivePopups()
        UIPopupManager.hideStaticPopups()
    }

    private static removeActivePopups() {
        UIPopupManager.activePopups.forEach((popup: ViewPopup) => {
            popup.removePopup()
        })
    }

    // Color and Icon selection popups are implemented differently than others and need to be handled differently
    private static hideStaticPopups() {
        const staticPopups = document.querySelectorAll('.header_profile_selector_modal')
        staticPopups.forEach((staticPopup: Element) => {
            (staticPopup as HTMLDivElement).style.display = 'none'
        })
    }
}
